export const ASK_QUESTION = "ask_question";
export const SCHEDULE_SHOWING = "schedule_showing";
export const BUY_OR_SELL = "buy_sell";
export const RENT = "rent";
